import script from "./CreateRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRecord.vue?vue&type=script&setup=true&lang=js"

import "./CreateRecord.vue?vue&type=style&index=0&id=69ae28c0&lang=css"

const __exports__ = script;

export default __exports__